import { useCallback, useEffect, useState } from 'react';
import {
  checkInternetConnection,
  NO_INTERNET_MESSAGE,
} from '../utils/networkConnectivity';

const useNetworkStatus = () => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [isChecking, setIsChecking] = useState(false);

  const refresh = useCallback(async () => {
    setIsChecking(true);
    try {
      const isConnected = await checkInternetConnection();
      setIsOffline(!isConnected);
      return isConnected;
    } finally {
      setIsChecking(false);
    }
  }, []);

  useEffect(() => {
    const handleOffline = () => {
      setIsOffline(true);
    };

    const handleOnline = () => {
      checkInternetConnection().then((isConnected) => {
        setIsOffline(!isConnected);
      });
    };

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);

    checkInternetConnection().then((isConnected) => {
      setIsOffline(!isConnected);
    });

    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  return {
    isOffline,
    isChecking,
    refresh,
    message: NO_INTERNET_MESSAGE,
  };
};

export default useNetworkStatus;
